// extracted by mini-css-extract-plugin
module.exports = {"qty":"CartSummary_qty__1lDeR","msg":"CartSummary_msg__udspu","btn":"CartSummary_btn__1jSke"};